export const env = {
    appName: 'Reflex Time Back Office',
    versions: {
        app: '1.0.7',
    },
};
